import React, {Component} from 'react';
import {MemoryRouter, Route, Routes, Link} from 'react-router-dom';
import ReactGA from 'react-ga';
import DocumentTile from 'react-document-title';
import intl from 'react-intl-universal';
import {debounce} from 'underscore';
import {mobilecheck} from './utils/Utils'

import MapContainer from './scenes/MapContainer';
import Survey from './scenes/Survey';
import EndLanding from './scenes/EndLanding';
import CloseSurvey from './scenes/CloseSurvey';
import Landing from "./scenes/Landing";
import Error from "./scenes/Error";
import pkg from '../package.json';

import './index.css';
import {withNavigate} from "./WithNavigation";
import ConditionalMemoryRouter from "./components/ConditionalMemoryRouter";

const locales = {
    "en-US": require('./locales/en-US.js'),
    "zh-CN": require('./locales/zh-CN.js'),
    "es-ES": require('./locales/es-ES.js'),
    "it-IT": require('./locales/it-IT.js'),
    "km-KM": require('./locales/km-KM.js'),
    "vi-VI": require('./locales/vi-VI.js'),
    "pt-PT": require('./locales/pt-PT.js'),
};
const LandingWithNavigation = withNavigate(Landing);
const SurveyWithNavigation = withNavigate(Survey);
const EndLandingWithNavigation = withNavigate(EndLanding);
const CloseSurveyWithNavigation = withNavigate(CloseSurvey);
const MapContainerWithNavigation = withNavigate(MapContainer);
const ErrorWithNavigation = withNavigate(Error);


class ComapFrontend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initDone: false
        };
        this._handleWindowResize = debounce(this._handleWindowResize.bind(this), 100);
        this._isMounted = false;

        if (this.props.standalone) {
            this.props.appStore.setStandalone();
        }

        const trackingId = ComapFrontend.getTrackingId();

        new Promise(resolve => {
            (function (i, s, o, g, r, a, m) {
                i.GoogleAnalyticsObject = r;
                (i[r] =
                    i[r] ||
                    function () {
                        (i[r].q = i[r].q || []).push(arguments);
                    }),
                    (i[r].l = 1 * new Date());
                (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
                a.async = 1;
                a.src = g;
                a.addEventListener("load", resolve);
                m.parentNode.insertBefore(a, m);
            })(
                window,
                document,
                "script",
                "https://www.google-analytics.com/analytics.js",
                "ga"
            );
            window.ga("create", trackingId, "auto");
            window.ga("send", "pageview");
        }).then(() => {
            ReactGA.initialize(trackingId, {
                debug: false,
                standardImplementation: true,
                gaOptions: {
                    name: this.props.appStore.branchId + '_' + this.props.appStore.projectId,
                    userId: this.props.appStore.responseID,
                    hostname: window.location.origin
                }
            });
        });
    }

    static getTrackingId() {
        if (window.location.href && (window.location.href.indexOf('staging') > -1 || window.location.href.indexOf('localhost') > -1)) {
            return 'UA-22148943-38';
        }
        //PROD
        return 'UA-22148943-32';
    }

    componentDidMount() {
        const {appStore} = this.props;
        this._isMounted = true;
        this.loadLocales();

        window.addEventListener('resize', this._handleWindowResize);

        window.onbeforeunload = e => {
            if (!appStore.isDirty) {
                e.preventDefault();
                delete e['returnValue'];
                return undefined;
            }

            return '';
        };
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('resize', this._handleWindowResize);
    }

    _handleWindowResize() {
        if (this._isMounted) {
            this.props.appStore.setIsMobile(mobilecheck());
            if (this.props.appStore.isMobile) {
                //Note: removing this line fixes the Android closing issue...
                //this.props.appStore.setDrawer({open: false});
            } else {
                this.props.appStore.setDrawer({
                    open: true,
                    active: Object.keys(this.props.appStore.appConfig.questions).filter((type) => this.props.appStore.appConfig.questions[type].length > 0)[0]
                });
            }
        }
    }

    loadLocales() {
        const {appStore} = this.props;
        const currentLocale = appStore.meta.type.lang || 'en-US';
        document.documentElement.lang = currentLocale;//let's e.g. GoogleTranslate prompt to translate page if not matching user's preferences
        intl.init({
            currentLocale: currentLocale,
            locales
        }).then(() => {
            this.setState({
                initDone: true
            });
        });
    }


    currentPhase() {
        const {appStore} = this.props;
        const meta = appStore.meta;
        if (window.location.href && meta && meta.phase) {
            if (window.location.pathname.indexOf('draft') > -1) {
                return meta.phase.draft;
            } else if (window.location.pathname.indexOf('staging') > -1) {
                return meta.phase.staging;
            }
            return meta.phase.production;
        }
    }

    isClosed() {
        return this.currentPhase()['CLOSED'];
    };

    render() {
        const {appStore} = this.props;
        const branchDisplayName = appStore.branchDisplayName;
        appStore.tracking.pageview(window.location.hash);

        const ErrorPage = ({history}) => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.error_page', {branch_name: branchDisplayName})}>
                    <ErrorWithNavigation appStore={appStore}/>
                </DocumentTile>
            )
        };

        const End = ({history}) => {
            console.log("Running End", history);

            return (
                <DocumentTile title={intl.get('DocumentTitle.end_page', {branch_name: branchDisplayName})}>
                    <EndLandingWithNavigation appStore={appStore}/>
                </DocumentTile>
            )
        };

        const Close = () => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.closed', {branch_name: branchDisplayName})}>
                    <CloseSurvey/>
                </DocumentTile>
            )
        };

        const getElement = (useLocation) => {
            if (useLocation === '/survey') {
                return <SurveyWithNavigation appStore={appStore}/>;
            } else if (useLocation === '/end') {
                return <EndLandingWithNavigation appStore={appStore}/>;
            } else if (useLocation === '/info') {
                return <LandingWithNavigation appStore={appStore}/>;
            } else {
                return <MapContainerWithNavigation appStore={appStore}
                                                   emptyResponseRoute={this.props.useLocation === "/empty-response"}/>
            }

        }

        return (
            this.state.initDone &&
            <div className="ComapFrontend">
                <ConditionalMemoryRouter renderWithRouter={this.props.renderWithRouter}>
                    <Link aria-label="Skip to info page"
                          className="offscreen"
                          to={`/info`}>Skip to Info Page</Link>
                    <Link aria-label="Skip to survey page"
                          className="offscreen"
                          to={`/survey`}>Skip to Survey Page</Link>
                    <Routes>
                        <Route path={this.props.location || "/"} element={getElement(this.props.useLocation)}/>
                        <Route path={this.props.location || "/survey"}
                               element={<SurveyWithNavigation appStore={appStore}/>}/>
                        <Route path={this.props.location || "/end"}
                               element={<EndLandingWithNavigation appStore={appStore}/>}/>
                        <Route path={this.props.location || "/info"}
                               element={<LandingWithNavigation appStore={appStore}/>}/>
                        <Route element={<ErrorWithNavigation appStore={appStore}/>}/>
                        {this.isClosed() && <Route element={<CloseSurveyWithNavigation appStore={appStore}/>}/>}
                    </Routes>

                    {this.isClosed() && Close()}

                    {!this.props.standalone && (
                        <div className="version">
                            comap-frontend v{pkg.version}
                        </div>
                    )}
                </ConditionalMemoryRouter>
            </div>
        );
    }
}

export default ComapFrontend;



// WEBPACK FOOTER //
// ./src/ComapFrontend.js